import { useState } from "react";
import { FaCheck,FaCopy } from "react-icons/fa";
import { useLanguage } from "../lang/LanguageContext";

export default function PublicationBibtex({ bibtex, button_text }) {
  const [isOpen, setIsOpen] = useState(false);
  const [copied, setCopied] = useState(false);
  const {  strings} = useLanguage();

  const copyToClipboard = () => {
    navigator.clipboard.writeText(bibtex);
    setCopied(true);

    // Revient à l'état "copier" après 2 secondes
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div>
      {/* Bouton d'ouverture */}
      <button
        className="bg-blue-600 text-white px-3 py-1 rounded hover:bg-blue-700"
        onClick={() => setIsOpen(true)}
      >
        BibTeX
      </button>

      {/* Popup modale */}
      {isOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          <div className="bg-white rounded-lg shadow-lg max-w-lg w-full p-4">
            <h2 className="text-xl font-bold mb-2">BibTeX</h2>
            <pre className="bg-gray-100 p-3 rounded text-sm overflow-x-auto">
              {bibtex}
            </pre>

            <div className="flex justify-end space-x-2 mt-4">
              <button
                className="bg-gray-300 px-3 py-1 rounded hover:bg-gray-400"
                onClick={() => setIsOpen(false)}
              >
                {strings.featuredPublications.bib_close}
              </button>

              <button
                className={`px-3 py-1 rounded flex items-center space-x-1 ${
                  copied
                    ? "bg-green-600 text-white"
                    : "bg-blue-600 text-white hover:bg-blue-700"
                }`}
                onClick={copyToClipboard}
              >
                {copied ? <FaCheck size={16} /> : <FaCopy size={16} />}
                <span>{copied ? strings.featuredPublications.bib_copied : strings.featuredPublications.bib_copy}</span>
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
